import { Nav } from '../components/portfolio/Nav';
import { Footer } from '../components/portfolio/Footer';
import { Hero } from '../components/portfolio/Hero';
import { Problem } from '../components/portfolio/Problem';
import { WhatWeBuild } from '../components/portfolio/WhatWeBuild';
import { ByTheNumbers } from '../components/portfolio/ByTheNumbers';
import { FeaturedSystems } from '../components/portfolio/FeaturedSystems';
import { WhyChooseUs } from '../components/portfolio/WhyChooseUs';
import { DiagnosticTeaser } from '../components/portfolio/DiagnosticTeaser';
import { HowWeWork } from '../components/portfolio/HowWeWork';
import { CTA } from '../components/portfolio/CTA';
import { SnapshotModal } from '../components/snapshot/SnapshotModal';

export default function PortfolioPage() {
    return (
        <div
            className="min-h-screen bg-[var(--ink-0)] text-[var(--text)]"
            data-testid="portfolio-page"
        >
            <Nav />
            <main>
                <Hero />
                <Problem />
                <WhatWeBuild />
                <ByTheNumbers />
                <FeaturedSystems />
                <WhyChooseUs />
                <DiagnosticTeaser />
                <HowWeWork />
                <CTA />
            </main>
            <Footer />
            <SnapshotModal />
        </div>
    );
}
